import actionTypes from '../constants/action-types';

const fetchUserFeatures = () => ({
  type: actionTypes.FETCH_USER_FEATURES,
});

export default fetchUserFeatures;
